import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { RootState } from '@/redux/store';
import { USER_ROLES } from '@/types/user';
import { hasAnyUserRole } from '@/utils/roles';

const Unauthorized = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const userRole = useSelector((state: RootState) => state.user.role);

  const handleGoBack = () => {
    const returnPath = (location.state as { from?: string } | null)?.from;

    if (returnPath && !returnPath.startsWith('/users')) {
      navigate(returnPath, { replace: true });
      return;
    }

    if (hasAnyUserRole(userRole, USER_ROLES.CORPORATE_ADMIN)) {
      navigate('/corporate?tab=employees', { replace: true });
      return;
    }

    navigate('/', { replace: true });
  };

  return (
    <div
      className="min-h-screen flex flex-col items-center justify-center"
      data-testid="unauthorized_page"
    >
      <div className="max-w-md rounded-lg bg-white p-8 shadow-md">
        <h1 className="mb-4 text-2xl font-bold text-red-600">Unauthorized</h1>
        <p className="text-gray-700">
          You are unauthorized to access this page. If you think this is a mistake, please email{' '}
          <a href="mailto:tech@pmxhealth.com" className="text-blue-600 hover:underline">
            tech@pmxhealth.com
          </a>
        </p>
        <div className="mt-6">
          <Button type="button" variant="outline" onClick={handleGoBack}>
            Go Back
          </Button>
        </div>
      </div>
    </div>
  );
};

export default Unauthorized;
